import React from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const PrimaryButton = ({ children, className, ...props }) => {
  return (
    <button
      className={twMerge(
        "inline-flex items-center justify-center rounded-md bg-[#0270a9] px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-[#025c86] focus:outline-none focus:ring-2 focus:ring-[#0270a9] focus:ring-offset-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};

export const SecondaryButton = ({ children, className, ...props }) => {
  return (
    <button
      className={twMerge(
        "inline-flex items-center justify-center rounded-md border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-200 transition-colors",
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};